var _path, _ellipse, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWindow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
  fill: "#BCD9C9"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.5,
  cy: 33,
  rx: 18.5,
  ry: 20,
  fill: "white"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 33,
  r: 20.25,
  stroke: "#727D79",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.2652 40.6841V40.7341H41.3152H42.9527C43.2561 40.7341 43.4961 40.9952 43.4961 41.2774C43.4961 41.582 43.2574 41.8207 42.9527 41.8207H21.5933C21.2887 41.8207 21.05 41.582 21.05 41.2774C21.05 40.9728 21.2887 40.7341 21.5933 40.7341H23.2546H23.3046V40.6841V24.5933C23.3046 24.2887 23.5433 24.05 23.8479 24.05H40.7219C41.0265 24.05 41.2652 24.2887 41.2652 24.5933V40.6841ZM40.1048 40.7341H40.1548V40.6841V33.5405V33.4905H40.1048H32.8664H32.8163V33.5405V40.6841V40.7341H32.8664H40.1048ZM40.1048 32.4039H40.1548V32.3539V25.2104V25.1604H40.1048H32.8664H32.8163V25.2104V32.3539V32.4039H32.8664H40.1048ZM31.7297 25.2104V25.1604H31.6797H24.4412H24.3912V25.2104V32.3539V32.4039H24.4412H31.6797H31.7297V32.3539V25.2104ZM24.4412 33.4905H24.3912V33.5405V40.6841V40.7341H24.4412H31.656H31.706V40.6841V33.5405V33.4905H31.656H24.4412Z",
  fill: "#EE8322",
  stroke: "white",
  strokeWidth: 0.1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.3871 30.0872L35.1325 27.8326C34.9147 27.6148 34.9147 27.2667 35.1325 27.0489C35.3503 26.8311 35.6984 26.8311 35.9162 27.0489L38.1708 29.3035C38.3886 29.5213 38.3886 29.8694 38.1708 30.0872C38.0632 30.1948 37.9344 30.2387 37.779 30.2387C37.6236 30.2387 37.4948 30.1948 37.3871 30.0872Z",
  fill: "#EE8322",
  stroke: "white",
  strokeWidth: 0.1
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5147 28.1973C38.3593 28.1973 38.2305 28.1534 38.1229 28.0458L37.1736 27.0965C36.9558 26.8787 36.9558 26.5306 37.1736 26.3128C37.3914 26.095 37.7394 26.095 37.9572 26.3128L38.9065 27.2621C39.1243 27.4799 39.1243 27.828 38.9065 28.0458C38.7989 28.1534 38.6701 28.1973 38.5147 28.1973Z",
  fill: "#EE8322",
  stroke: "white",
  strokeWidth: 0.1
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWindow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-window.32c058e8b24e1af960512ce5afe115ce.svg";